import logo from '../../assets/logo.png'
import css from './Contrato.module.css'

const Contrato = ()=> (  
  <div className={css.main}>
    <img className={css.imagen} src={logo} alt="logo" />
    <div className={css.content}>
      <h1 className={css.title}>Ya has firmado las condiciones de contratación de mundoestudiante</h1>
      <p className={css.text}>
        Si tienes alguna duda, no dudes en ponerte en contacto con nosotros a través de nuestro correo electrónico{' '}
        <a className={css.link} href="mailto:hola@mundoestudiante.com">
          hola@mundoestudiante.com
        </a>
      </p>
      <p className={css.text}>Gracias por confiar en nosotros</p>
    </div>
  </div>
)

export default Contrato